// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M10,0C4.5,0,0,4.5,0,10c0,4.3,2.7,8.1,6.8,9.5l1.7-5.8l0.3-1C7.7,12.3,7,11.2,7,10c0-1.7,1.3-3,3-3s3,1.3,3,3
		c0,1.2-0.7,2.3-1.9,2.8l0.3,1l1.8,5.8c5.3-1.7,8.1-7.3,6.4-12.6C18.3,2.8,14.4,0,10,0z M13.8,18.1l-1.5-4.9
		c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.7,0.7-1.1l0.1-0.3c0-0.1,0.1-0.2,0.1-0.3
		c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,0.2,0,0.5,0,0.5c0,0.2,0.1,0.3,0.1,0.4
		c0,0.2,0.1,0.3,0.1,0.4c0.1,0.3,0.3,0.6,0.4,0.8c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.3
		l-1.5,4.9c-4.5-2.1-6.4-7.5-4.3-12s7.5-6.4,12-4.3s6.4,7.5,4.3,12C17.3,15.7,15.7,17.3,13.8,18.1z" transform="translate(2, 2)" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-open-source-DygkL3Z7.js.map
